import React from 'react'
import { GetMonthNameByNumber } from './Helper/GetMonthNameByNumber';
import { useHistory } from "react-router-dom";
import { LinearProgress } from '@mui/material';
import { FormatMoney } from '../../../Helpers/FormatNumber';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import CellTowerIcon from '@mui/icons-material/CellTower';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import StarsIcon from '@mui/icons-material/Stars';

export const TablaUnidadesScorecardGerente = ({ boxstate, data, initialStateboxfiltros, boxInicial, filtroModificado, idasesor, asesor, ruta = "gerente" }) => {

    const history = useHistory();
console.log(data)
    const formatPorcentaje = (real, objetivo) => {
        if (objetivo === 0 && real === 0) {
            return null;
        }

        if (objetivo === 0) {
            return 100;
        }

        const porcentaje = (real / objetivo) * 100;

        return Math.min(porcentaje, 100);
    };

    const getBarColor = (porcentaje) => {
        if (porcentaje <= 60) {
            return "#f44336";
        } else if (porcentaje > 60 && porcentaje < 80) {
            return "#ffc107";
        } else {
            return "#035917";
        }
    };

    const capitalizeWords = (str) => {
        return str
            ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
            : "";
    };

    const onDetalleMensual = (linea) => {

        if (linea.toLowerCase() === "garantia extendida") {
            history.push({
                pathname: "/Ventas/PaqueteServicio",
                state: "GE",
            });
        }
        if (linea.toLowerCase() === "poliza mantenimiento") {
            history.push({
                pathname: "/Ventas/PaqueteServicio",
                state: "PM",
            });
        }
        else {
            // Verificar si hay datos en localStorage para 'DatosFiltro'
            const datosFiltro = localStorage.getItem("DatosFiltro");

            const filtroParaGuardar = filtroModificado ? boxstate : boxInicial;

            const boxstateToSave = {
                ...filtroParaGuardar,
                pv: {
                    ...filtroParaGuardar.pv,
                    sucursal: Array.isArray(filtroParaGuardar.pv.sucursal) && filtroParaGuardar.pv.sucursal.length === 1
                        ? [{ ...filtroParaGuardar.pv.sucursal[0], sucursal: capitalizeWords(filtroParaGuardar.pv.sucursal[0].sucursal) }]
                        : [],  // Si hay 0 o más de 1 sucursal, se guarda como vacío
                    vendedor: [
                        {
                            idvendedor: idasesor,
                            vendedor: asesor
                        }
                    ]
                }
            };

            // Si hay datos en localStorage, usar initialStateboxfiltros(); de lo contrario, usar boxstate
            const data = {
                boxstate: boxstateToSave,
                linea,
                ruta
            };

            // Eliminar el item 'DatosFiltro' del localStorage
            localStorage.removeItem("DatosFiltro");

            // Navegar a la ruta especificada, pasando el objeto data en el estado
            history.push({
                pathname: "/Ventas/DetalleFacturacionMensual",
                state: data,
            });

        }
    };


    const onDetalleAcumulado = (linea) => {
        if (linea.toLowerCase() === "garantia extendida") {
            history.push({
                pathname: "/Ventas/PaqueteServicio",
                state: "GE",
            });
        }
        else if (linea.toLowerCase() === "poliza mantenimiento") {
            history.push({
                pathname: "/Ventas/PaqueteServicio",
                state: "PM",
            });
        }
        else {
            // Verificar si hay datos en localStorage para 'DatosFiltro'
            const datosFiltro = localStorage.getItem("DatosFiltro");

            // Si hay datos en localStorage, usar initialStateboxfiltros(); de lo contrario, usar boxstate
            const data = {
                boxstate: datosFiltro ? initialStateboxfiltros() : boxstate,
                linea,
            };

            // Eliminar el item 'DatosFiltro' del localStorage
            localStorage.removeItem("DatosFiltro");

            history.push({
                pathname: "/Ventas/DetalleFacturacionAcumulado",
                state: data,
            });
        }
    };

    //Maquinaria
    const maquinariaFiltrada = data.filter((item) =>
        ["tractores", "implementos", "jardineros"].includes(item.linea.toLowerCase())
    );

    const totalMaquinariaImporte = maquinariaFiltrada.reduce((acc, item) => acc + item.unidades_vendidas, 0);
    const totalMaquinariaObjetivo = maquinariaFiltrada.reduce((acc, item) => acc + item.objetivo, 0);
    const totalMaquinariaAcumuladoImporte = maquinariaFiltrada.reduce((acc, item) => acc + item.unidades_vendidas_acumulado, 0);
    const totalMaquinariaProyectadoAcumuladoObjetivo = maquinariaFiltrada.reduce((acc, item) => acc + item.objetivo_acumulado, 0);

    const porcentajeMensualMaquinaria = formatPorcentaje(
        totalMaquinariaImporte,
        totalMaquinariaObjetivo
    );
    const porcentajeAcumuladoMaquinaria = formatPorcentaje(
        totalMaquinariaAcumuladoImporte,
        totalMaquinariaProyectadoAcumuladoObjetivo
    );
    const barColorMensualMaquinaria = getBarColor(porcentajeMensualMaquinaria);
    const barColorAcumuladoMaquinaria = getBarColor(porcentajeAcumuladoMaquinaria);


    //Autoguiado
    const autoguiadoFiltrada = data.filter((item) =>
        ["autoguiado", "drones"].includes(item.linea.toLowerCase())
    );

    const totalAutoguiadoImporte = autoguiadoFiltrada.reduce((acc, item) => acc + item.unidades_vendidas, 0);
    const totalAutoguiadoObjetivo = autoguiadoFiltrada.reduce((acc, item) => acc + item.objetivo, 0);
    const totalAutoguiadoAcumuladoImporte = autoguiadoFiltrada.reduce((acc, item) => acc + item.unidades_vendidas_acumulado, 0);
    const totalAutoguiadoProyectadoAcumuladoObjetivo = autoguiadoFiltrada.reduce((acc, item) => acc + item.objetivo_acumulado, 0);

    const porcentajeMensualAutoguiado = formatPorcentaje(
        totalAutoguiadoImporte,
        totalAutoguiadoObjetivo,
    );
    const porcentajeAcumuladoAutoguiado = formatPorcentaje(
        totalAutoguiadoAcumuladoImporte,
        totalAutoguiadoProyectadoAcumuladoObjetivo
    );
    const barColorMensualAutoguiado = getBarColor(porcentajeMensualAutoguiado);
    const barColorAcumuladoAutoguiado = getBarColor(porcentajeAcumuladoAutoguiado);


    //Usados
    const usadosFiltrada = data.filter((item) =>
        ["trilladoras seminuevas", "tractores seminuevos"].includes(item.linea.toLowerCase())
    );

    const totalUsadoImporte = usadosFiltrada.reduce((acc, item) => acc + item.unidades_vendidas, 0);
    const totalUsadoObjetivo = usadosFiltrada.reduce((acc, item) => acc + item.objetivo, 0);
    const totalUsadoAcumuladoImporte = usadosFiltrada.reduce((acc, item) => acc + item.unidades_vendidas_acumulado, 0);
    const totalUsadoProyectadoAcumuladoObjetivo = usadosFiltrada.reduce((acc, item) => acc + item.objetivo_acumulado, 0);

    const porcentajeMensualUsado = formatPorcentaje(
        totalUsadoImporte,
        totalUsadoObjetivo
    );
    const porcentajeAcumuladoUsado = formatPorcentaje(
        totalUsadoAcumuladoImporte,
        totalUsadoProyectadoAcumuladoObjetivo
    );

    const barColorMensualUsado = getBarColor(porcentajeMensualMaquinaria);
    const barColorAcumuladoUsado = getBarColor(porcentajeAcumuladoMaquinaria);

    //Posventa
    const posventaFiltrada = data.filter((item) =>
        ["garantia extendida", "poliza mantenimiento"].includes(item.linea.toLowerCase())
    );

    const totalPosventaImporte = posventaFiltrada.reduce((acc, item) => acc + item.unidades_vendidas, 0);
    const totalPosventaObjetivo = posventaFiltrada.reduce((acc, item) => acc + item.objetivo, 0);
    const totalPosventaAcumuladoImporte = posventaFiltrada.reduce((acc, item) => acc + item.unidades_vendidas_acumulado, 0);
    const totalPosventaProyectadoAcumuladoObjetivo = posventaFiltrada.reduce((acc, item) => acc + item.objetivo_acumulado, 0);

    const porcentajeMensualPosventa = formatPorcentaje(
        totalPosventaImporte,
        totalPosventaObjetivo
    );
    const porcentajeAcumuladoPosventa = formatPorcentaje(
        totalPosventaAcumuladoImporte,
        totalPosventaProyectadoAcumuladoObjetivo
    );

    const barColorMensualPosventa = getBarColor(porcentajeMensualPosventa);
    const barColorAcumuladoPosventa = getBarColor(porcentajeAcumuladoPosventa);

    const aliadoFiltrado = data.filter(item => item.linea.toLowerCase() === "producto aliado");

    const totalAliadoObjetivo = aliadoFiltrado.reduce((acc, item) => acc + item.objetivo, 0);
    const totalAliadoImporte = aliadoFiltrado.reduce((acc, item) => acc + item.unidades_vendidas, 0);
    const totalAliadoProyectadoAcumuladoObjetivo = aliadoFiltrado.reduce((acc, item) => acc + item.objetivo_acumulado, 0);
    const totalAliadoAcumuladoImporte = aliadoFiltrado.reduce((acc, item) => acc + item.unidades_vendidas_acumulado, 0);

    // Porcentaje y colores
    const porcentajeMensualAliado = formatPorcentaje(totalAliadoImporte, totalAliadoObjetivo);
    const porcentajeAcumuladoAliado = formatPorcentaje(totalAliadoAcumuladoImporte, totalAliadoProyectadoAcumuladoObjetivo);

    const barColorMensualAliado = getBarColor(porcentajeMensualAliado);
    const barColorAcumuladoAliado = getBarColor(porcentajeAcumuladoAliado);

    // Refacciones: el backend regresa esta línea en pesos, no en unidades.
    // Se excluye del listado/total de unidades y se muestra aparte, en pesos.
    const dataSinRefacciones = data.filter((item) => item.linea.toLowerCase() !== "refacciones");
    const refaccionesFiltrada = data.filter((item) => item.linea.toLowerCase() === "refacciones");

    const totalRefaccionesObjetivo = refaccionesFiltrada.reduce((acc, item) => acc + item.objetivo, 0);
    const totalRefaccionesImporte = refaccionesFiltrada.reduce((acc, item) => acc + item.unidades_vendidas, 0);
    const totalRefaccionesProyectadoAcumuladoObjetivo = refaccionesFiltrada.reduce((acc, item) => acc + item.objetivo_acumulado, 0);
    const totalRefaccionesAcumuladoImporte = refaccionesFiltrada.reduce((acc, item) => acc + item.unidades_vendidas_acumulado, 0);

    const porcentajeMensualRefacciones = formatPorcentaje(totalRefaccionesImporte, totalRefaccionesObjetivo);
    const porcentajeAcumuladoRefacciones = formatPorcentaje(totalRefaccionesAcumuladoImporte, totalRefaccionesProyectadoAcumuladoObjetivo);

    const barColorMensualRefacciones = getBarColor(porcentajeMensualRefacciones);
    const barColorAcumuladoRefacciones = getBarColor(porcentajeAcumuladoRefacciones);


    return (
        <div className='tabla-importes-scorecard scroll'>
            <table cellPadding={0} cellSpacing={0} >
                <thead>
                    <tr>
                        <th colSpan={2}></th>
                        <th colSpan={3}>
                            <div>{GetMonthNameByNumber(boxstate.periodofin)}</div>
                        </th>
                        <th colSpan={3}>
                            <div>
                                {GetMonthNameByNumber(boxstate.periodoinicio)}{" "}
                                {boxstate.ejercicioinicio} a{" "}
                                {GetMonthNameByNumber(boxstate.periodofin)}{" "}
                                {boxstate.ejerciciofin}
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th colSpan={2}>
                            <div>Línea</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {dataSinRefacciones.map((score, index) => {
                        const porcentajeMensual = formatPorcentaje(
                            score.unidades_vendidas,
                            score.objetivo
                        );
                        const porcentajeAcumulado = formatPorcentaje(
                            score.unidades_vendidas_acumulado,
                            score.objetivo_acumulado
                        );
                        const barColorMensual = getBarColor(porcentajeMensual);
                        const barColorAcumulado = getBarColor(porcentajeAcumulado);

                        return (
                            <React.Fragment key={score.linea}>
                                {/* Total Maquinaria (ya existente) */}
                                {score.linea.toLowerCase() === "tractores" && (
                                    <tr className="importes-totales" >
                                        <td colSpan={2} className='titulo-subtotales'><div className='titulo-suntotal-div'><AgricultureIcon /> <strong>Maquinaria</strong></div></td>
                                        <td className='titulo-subtotal-segunda-columna'>
                                            {totalMaquinariaObjetivo}
                                        </td>
                                        <td>
                                            {totalMaquinariaImporte}
                                        </td>
                                        <td>
                                            <span className="percentaje">
                                                {totalMaquinariaImporte !== 0 || totalMaquinariaObjetivo !== 0
                                                    ? `${porcentajeMensualMaquinaria.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeMensualMaquinaria}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorMensualMaquinaria,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {totalMaquinariaProyectadoAcumuladoObjetivo}

                                        </td>
                                        <td>
                                            {totalMaquinariaAcumuladoImporte}
                                        </td>
                                        <td>
                                            <span className="percentaje">
                                                {totalMaquinariaProyectadoAcumuladoObjetivo !== 0 ||
                                                    totalMaquinariaProyectadoAcumuladoObjetivo !== 0
                                                    ? `${porcentajeAcumuladoMaquinaria.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeAcumuladoMaquinaria}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumuladoMaquinaria,
                                                    },
                                                }}
                                            />
                                        </td>
                                    </tr>
                                )}

                                {/* 🔽 NUEVA FILA: Total Agricultura de Precisión */}
                                {score.linea.toLowerCase() === "autoguiado" && (

                                    <tr tr className="importes-totales">
                                        <td colSpan={2} className='titulo-subtotales'><div className='titulo-suntotal-div'><CellTowerIcon /><strong>Agricultura de Precisión</strong></div></td>
                                        <td className='titulo-subtotal-segunda-columna'>
                                            {totalAutoguiadoObjetivo}
                                        </td>
                                        <td>
                                            {totalAutoguiadoImporte}
                                        </td>
                                        <td>
                                            <span className="percentaje">
                                                {totalAutoguiadoImporte !== 0 || totalAutoguiadoObjetivo !== 0
                                                    ? `${porcentajeMensualAutoguiado.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeMensualAutoguiado}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorMensualAutoguiado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {totalAutoguiadoProyectadoAcumuladoObjetivo}
                                        </td>
                                        <td>

                                            {totalAutoguiadoAcumuladoImporte}
                                        </td>
                                        <td>
                                            <span className="percentaje">
                                                {totalAutoguiadoAcumuladoImporte !== 0 ||
                                                    totalAutoguiadoProyectadoAcumuladoObjetivo !== 0
                                                    ? `${porcentajeAcumuladoAutoguiado.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeAcumuladoAutoguiado}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumuladoAutoguiado,
                                                    },
                                                }}
                                            />
                                        </td>
                                    </tr>
                                )}

                                {score.linea.toLowerCase() === "tractores seminuevos" && (
                                    <tr className="importes-totales">
                                        <td colSpan={2} className='titulo-subtotales'><div className='titulo-suntotal-div'><AgricultureIcon /><strong>Maquinaria Seminueva</strong></div></td>
                                        <td className='titulo-subtotal-segunda-columna'>
                                            {totalUsadoObjetivo}
                                        </td>
                                        <td>
                                            {totalUsadoImporte}
                                        </td>
                                        <td>
                                            <span className="percentaje">
                                                {totalUsadoImporte !== 0 || totalUsadoObjetivo !== 0
                                                    ? `${porcentajeMensualUsado.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeMensualUsado}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorMensualUsado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {totalUsadoProyectadoAcumuladoObjetivo}
                                        </td>
                                        <td>
                                            {totalUsadoAcumuladoImporte}
                                        </td>
                                        <td>
                                            <span className="percentaje">
                                                {totalUsadoAcumuladoImporte !== 0 ||
                                                    totalUsadoProyectadoAcumuladoObjetivo !== 0
                                                    ? `${porcentajeAcumuladoUsado.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeAcumuladoUsado}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumuladoUsado,
                                                    },
                                                }}
                                            />
                                        </td>
                                    </tr>
                                )}

                                {score.linea.toLowerCase() === "garantia extendida" && (
                                    <tr className="importes-totales">
                                        <td colSpan={2} className='titulo-subtotales'><div className='titulo-suntotal-div'><StarsIcon /><strong>Posventa</strong></div></td>
                                        <td className='titulo-subtotal-segunda-columna'>
                                            {totalPosventaObjetivo}
                                        </td>
                                        <td>
                                            {totalPosventaImporte}
                                        </td>
                                        <td>
                                            <span className="percentaje">
                                                {totalPosventaImporte !== 0 || totalPosventaObjetivo !== 0
                                                    ? `${porcentajeMensualPosventa.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeMensualPosventa}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorMensualPosventa,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {totalPosventaProyectadoAcumuladoObjetivo}
                                        </td>
                                        <td>
                                            {totalPosventaAcumuladoImporte}
                                        </td>
                                        <td>
                                            <span className="percentaje">
                                                {totalPosventaAcumuladoImporte !== 0 ||
                                                    totalPosventaProyectadoAcumuladoObjetivo !== 0
                                                    ? `${porcentajeAcumuladoPosventa.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeAcumuladoPosventa}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumuladoPosventa,
                                                    },
                                                }}
                                            />
                                        </td>
                                    </tr>
                                )}


                                {score.linea.toLowerCase() === "producto aliado" ? (
                                    <tr className="importes-totales separacion">
                                        <td colSpan={2} className='titulo-subtotales'>
                                            <div className='titulo-suntotal-div'>
                                                <GroupWorkIcon />
                                                <strong>Producto Aliado</strong>
                                            </div>
                                        </td>
                                        <td className='titulo-subtotal-segunda-columna'>
                                            {totalAliadoObjetivo}
                                        </td>
                                        <td>
                                            {totalAliadoImporte}
                                        </td>
                                        <td>
                                            <span className="percentaje">
                                                {totalAliadoImporte !== 0 || totalAliadoObjetivo !== 0
                                                    ? `${porcentajeMensualAliado.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeMensualAliado}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorMensualAliado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {totalAliadoProyectadoAcumuladoObjetivo}
                                        </td>
                                        <td>
                                            {totalAliadoAcumuladoImporte}
                                        </td>
                                        <td>
                                            <span className="percentaje">
                                                {totalAliadoAcumuladoImporte !== 0 || totalAliadoProyectadoAcumuladoObjetivo !== 0
                                                    ? `${porcentajeAcumuladoAliado.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeAcumuladoAliado}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumuladoAliado,
                                                    },
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ) : (
                                    // Fila normal para cualquier otra línea
                                    <tr>
                                        <td className={`celda-seaparacion-titulo ${score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}`}></td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                        >{capitalizeWords(score.linea)}</td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleMensual(score.linea)}>
                                            {score.objetivo}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleMensual(score.linea)}>
                                            {score.unidades_vendidas}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleMensual(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_vendidas !== 0 || score.objetivo !== 0
                                                    ? `${porcentajeMensual.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeMensual}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorMensual,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_acumulado}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_vendidas_acumulado}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_vendidas_acumulado !== 0 || score.objetivo_acumulado !== 0
                                                    ? `${porcentajeAcumulado.toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={porcentajeAcumulado}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                    </tr>
                                )}

                            </React.Fragment>

                        );
                    })}

                    {/* 👇 Fila de totales generales (unidades, sin Refacciones porque viene en pesos) */}
                    <tr className="importes-totales">
                        <td colSpan={2}>Importe Total</td>
                        <td className='titulo-subtotal-segunda-columna'>
                            {
                                dataSinRefacciones.reduce(
                                    (acumulador, item) =>
                                        acumulador + item.objetivo,
                                    0
                                    ,
                                    0
                                )}
                        </td>
                        <td>
                            {
                                dataSinRefacciones.reduce(
                                    (acumulador, item) => acumulador + item.unidades_vendidas,
                                    0
                                    ,
                                    0
                                )}
                        </td>
                        <td></td>
                        <td>
                            {
                                dataSinRefacciones.reduce(
                                    (acumulador, item) =>
                                        acumulador + item.objetivo_acumulado,
                                    0
                                    ,
                                    0
                                )}
                        </td>
                        <td>
                            {
                                dataSinRefacciones.reduce(
                                    (acumulador, item) => acumulador + item.unidades_vendidas_acumulado,
                                    0
                                    ,
                                    0
                                )}
                        </td>
                        <td></td>
                    </tr>

                    {/* 👇 Sección aparte para Refacciones: el backend la regresa en pesos, no en unidades */}
                    {refaccionesFiltrada.length > 0 && (
                        <>
                            <tr className="importes-totales nota-pesos-row">
                                <td colSpan={8} className="nota-pesos">
                                    * Los valores de esta sección están representados en pesos ($), no en unidades.
                                </td>
                            </tr>
                            <tr className="importes-totales">
                                <td colSpan={2} className='titulo-subtotales'><div className='titulo-suntotal-div'><StarsIcon /><strong>Posventa (Refacciones)</strong></div></td>
                                <td className='titulo-subtotal-segunda-columna'>
                                    {FormatMoney(totalRefaccionesObjetivo)}
                                </td>
                                <td>
                                    {FormatMoney(totalRefaccionesImporte)}
                                </td>
                                <td>
                                    <span className="percentaje">
                                        {totalRefaccionesImporte !== 0 || totalRefaccionesObjetivo !== 0
                                            ? `${porcentajeMensualRefacciones.toFixed(0)}%`
                                            : ""}
                                    </span>
                                    <LinearProgress
                                        variant="determinate"
                                        value={porcentajeMensualRefacciones}
                                        sx={{
                                            height: 10,
                                            borderRadius: 5,
                                            backgroundColor: "#e0e0e0",
                                            "& .MuiLinearProgress-bar": {
                                                backgroundColor: barColorMensualRefacciones,
                                            },
                                        }}
                                    />
                                </td>
                                <td>
                                    {FormatMoney(totalRefaccionesProyectadoAcumuladoObjetivo)}
                                </td>
                                <td>
                                    {FormatMoney(totalRefaccionesAcumuladoImporte)}
                                </td>
                                <td>
                                    <span className="percentaje">
                                        {totalRefaccionesAcumuladoImporte !== 0 || totalRefaccionesProyectadoAcumuladoObjetivo !== 0
                                            ? `${porcentajeAcumuladoRefacciones.toFixed(0)}%`
                                            : ""}
                                    </span>
                                    <LinearProgress
                                        variant="determinate"
                                        value={porcentajeAcumuladoRefacciones}
                                        sx={{
                                            height: 10,
                                            borderRadius: 5,
                                            backgroundColor: "#e0e0e0",
                                            "& .MuiLinearProgress-bar": {
                                                backgroundColor: barColorAcumuladoRefacciones,
                                            },
                                        }}
                                    />
                                </td>
                            </tr>
                        </>
                    )}
                </tbody>
            </table >
        </div>
    )
}
